import { generateLocalization, generateKeys } from '../utils';
export const competitionRules = generateLocalization('competitionRules', generateKeys({
    minimumBalance: {
        value: 'minimumBalance',
        localization: { id: '', defaultMessage: '' },
        label: 'Minimum account balance of {{balance}} required.',
        values: [
            'balance',
        ],
    },
    roundTrips: {
        value: 'roundTrips',
        localization: { id: '', defaultMessage: '' },
        label: 'Participants must have executed at least {{roundTrips}} trades during the competition in order to qualify for a prize.',
        values: [
            'roundTrips',
        ],
    },
    minimumTradingVolume: {
        value: 'minimumTradingVolume',
        localization: { id: '', defaultMessage: '' },
        label: 'Minimum Trading Volume of {{volume}} required.',
        values: [
            'volume',
        ],
    },
}));
